import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import TrustBar from '@/pages/home/components/TrustBar';
import CategoryDropdown from '@/pages/home/components/CategoryDropdown';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import WhatIsSection from '@/pages/home/components/WhatIsSection';
import PlatformComparison from '@/pages/home/components/PlatformComparison';
import CTASection from '@/pages/home/components/CTASection';
import ArticleCards from '@/pages/home/components/ArticleCards';
import Footer from '@/pages/home/components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL;

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'CSSSpreadsheet Hub',
  url: siteUrl,
  description: 'Find the best CSSBuy spreadsheet, Kakobuy spreadsheet, Superbuy spreadsheet and Oopbuy spreadsheet for agent shopping. Browse 14 curated categories of fashion, sneakers, streetwear and accessories updated weekly.',
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'CSSSpreadsheet Hub',
  url: siteUrl,
  description: 'CSSSpreadsheet Hub is the most complete resource for CSSBuy spreadsheet, Kakobuy spreadsheet, Superbuy spreadsheet and Oopbuy spreadsheet finds, agent shopping guides, and curated product discovery across 14 categories.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <TrustBar />

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              Quick Category Navigation
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mb-6">
              Select a category below to jump directly to the full collection on KASpreadsheet.
            </p>
            <div className="flex justify-center">
              <CategoryDropdown />
            </div>
          </div>
        </section>

        <CategoryGrid />
        <WhatIsSection />
        <PlatformComparison />
        <CTASection />
        <ArticleCards />
      </main>
      <Footer />
    </>
  );
}